import React, { Fragment } from "react";
import styles from "./ErrorMessages.module.scss";
import warningIcon from "../../assets/images/ic_warning.svg";
import { createPostFixedElementName } from "../../shared/helpers/element.naming";

export interface ErrorMessagesProps {
  name: string;
  title?: string;
  messages: string[];
}
export const ErrorMessages = (props: ErrorMessagesProps) => {
  const titleElementName = createPostFixedElementName(props.name, "title");
  return (
    <Fragment>
      {props.messages.length > 0 && (
        <div className={styles.outer_container}>
          <div className={styles.top_arrow} />
          <div className={styles.content_container}>
            <div className={styles.icon_container}>
              <img className={styles.icon} src={warningIcon} alt="" />
            </div>
            <div className={styles.messages_container}>
              {props.title && (
                <label id={titleElementName} data-name={titleElementName} className={styles.label_title}>
                  {props.title}
                </label>
              )}
              {props.messages.map((message, index) => (
                <label
                  id={createPostFixedElementName(props.name, index)}
                  data-name={createPostFixedElementName(props.name, index)}
                  key={index}
                  className={styles.label}
                >
                  {message}
                </label>
              ))}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
